module.exports = __webpack_public_path__ + "static/Crystal1-6bd17a02ed164ec082757b8c791a2355.png";